import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as LabelService from 'services/agents/label';

export const useLabelService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createLabel = async (data, options = {}) => {
    const { error, payload: label } = await LabelService.create({
      ...options,
      data,
      token
    });

    if (error) {
      toast.error('Cannot create label at this time');
      return { label: {} };
    }

    toast.success('Label created successfully.');
    return { label };
  };

  const deleteLabel = async (id, options = {}) => {
    const { error } = await LabelService.deleteOne(id, { ...options, token });

    if (error) {
      toast.error('Unable to delete label at this time.');
      return false;
    }

    toast.success('Label deleted successfully');
    return true;
  };

  const fetchLabel = async (id, options = {}) => {
    const { error, payload: label } = await LabelService.readById(id, { ...options, token });

    if (error) {
      toast.error(error);
      return { label: null };
    }

    return { label };
  };

  const fetchLabels = async (options = {}) => {
    const { error, payload } = await LabelService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { labels: [], size: 0 };
    }

    const {
      data: labels,
      meta: { size }
    } = payload;
    return { labels, size };
  };

  const searchLabels = async (keys, keyword, options = {}) => {
    const { error, payload } = await LabelService.search(keys, keyword, { ...options, token });

    if (error) {
      toast.error('Unable to fetch labels at this time.');
      return { labels: [], size: 0 };
    }

    const {
      data: labels,
      meta: { size }
    } = payload;
    return { labels, size };
  };

  const updateLabel = async (id, options = {}) => {
    const { error, payload } = await LabelService.updateById(id, { ...options, token });

    if (error) {
      toast.error('Unable to update label at this time.');
      return false;
    }

    toast.success('Label updated successfully');
    return payload || true;
  };

  const updateLabels = async (options = {}) => {
    const { error } = await LabelService.update({ ...options, token });

    if (error) {
      toast.error('Unable to update labels at this time.');
      return false;
    }

    toast.success('Labels updated successfully');
    return true;
  };

  const deleteLabels = async (options = {}) => {
    const { error } = await LabelService.deleteMany({ ...options, token });

    if (error) {
      toast.error('Unable to delete labels at this time.');
      return false;
    }

    toast.success('Labels deleted successfully');
    return true;
  };

  return {
    createLabel,
    deleteLabel,
    fetchLabel,
    fetchLabels,
    searchLabels,
    updateLabel,
    updateLabels,
    deleteLabels
  };
};
